import React from 'react';
import { Row, Col, Button } from 'antd';
import { handlers } from '../../helpers/helpers';

const { format } = require('rut.js');

const UserData = ({ setStep, patientData, refreshUserName }) => {

  const goToForm = () => {
    handlers.handleUserData({ testsResults: [] });
    refreshUserName();
    setStep(4);
  };

  const goToAdmission = () => {
    setStep(3);
  };


  return (
    <Row justify="center" className="user-data-container mt-80">
      <Col lg={24} md={24}>
        <h1 className="text-center mb-30">Datos personales</h1>
        <h3 className="text-center">Por favor, corrobora que tus datos estén correctos y confirma tu identidad</h3>
      </Col>
      {
        patientData &&
        <Col lg={22} md={22} className="gray-row p-30 mt-40">
          <Row justify="center">
            <Col lg={22} md={22}>
              <Row>
                <Col md={12}>
                  <Row>
                    <Col>
                      <p className="mr-10 mb-10">Nombre:</p>
                    </Col>
                    <Col>
                      <p className="text-bold">{patientData.full_name}</p>
                    </Col>
                  </Row>
                </Col>
                <Col md={12}>
                  <Row>
                    <Col>
                      <p className="mr-10">
                        {
                          patientData.document_type === 'passport'
                            ? 'Pasaporte'
                            : patientData.document_type === 'ce'
                              ? 'Carnet de extranjería'
                              : patientData.document_type.toUpperCase()
                        }:
                      </p>
                    </Col>
                    <Col>
                      <p className="text-bold">
                        {patientData.document_type === 'rut' ? format(patientData.document_number) : patientData.document_number}
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="mt-10">
                <Col md={12}>
                  <Row>
                    <Col>
                      <p className="mr-10">Edad:</p>
                    </Col>
                    <Col>
                      <p className="text-bold">{patientData.age} años</p>
                    </Col>
                  </Row>
                </Col>
                <Col md={12}>
                  <Row>
                    <Col>
                      <p className="mr-10">Teléfono:</p>
                    </Col>
                    <Col>
                      <p className="text-bold">{patientData.phone}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="mt-10">
                <Col md={24}>
                  <Row>
                    <Col>
                      <p className="mr-10 mb-0">Cargo:</p>
                    </Col>
                    <Col>
                      <p className="text-bold mb-0">{patientData.position}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      }
      <Col md={24} className="mt-70 mb-50">
        <Row justify="center">
          <Col md={7} className="mr-30">
            <Button onClick={goToAdmission} className="button-secondary" size="large" block>Los datos son incorrectos</Button>
          </Col>
          <Col md={7}>
            <Button type="primary" size="large" onClick={goToForm} block>Validar identidad</Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default UserData;